import React from 'react';
import TablaPartidos from '../../components/tables/Partidos';

const Partidos = () => {
    return (
        <TablaPartidos/>
    );
}
 
export default Partidos;